export const styles = {
  searchField: {
    "& .MuiInputLabel-root.MuiFormLabel-root": {
      fontWeight: 500,
    },
  },
};
